import getSkypeOptions from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('selectSkypeNotificationOption', function selectSkypeNotificationOption(notificationType, isImNotification) {
    var optionState = getSkypeOptions();
    if (isImNotification) {
        optionState.imNotification = notificationType;
    }
    else {
        optionState.callNotification = notificationType;
    }
});
//# sourceMappingURL=selectSkypeNotificationOption.js.map